import {useCallback, useSyncExternalStore} from 'react';
import type {Component, Editor} from 'grapesjs';
import {POSTERMYWALL_DESCRIPTION_TEXT_TYPE} from '@FormMakerReact/components/postermywall-description-text/postermywall-description-text';

export function useSelectedDescription(editor: Editor): Component | null {
  const subscribe = useCallback(
    (onChange: () => void) => {
      editor.on('component:selected component:deselected', onChange);
      return (): void => {
        editor.off('component:selected component:deselected', onChange);
      };
    },
    [editor]
  );

  const getSnapshot = useCallback((): Component | null => {
    const selected = editor.getSelected();
    if (!selected || selected.get('type') !== POSTERMYWALL_DESCRIPTION_TEXT_TYPE) {
      return null;
    }
    return selected;
  }, [editor]);
  return useSyncExternalStore(subscribe, getSnapshot);
}
